// extracted by mini-css-extract-plugin
export var about = "about-module--about--wtn1u";
export var aboutContact = "about-module--about-contact--ptJbv";
export var aboutDescription = "about-module--about-description--WUS1g";
export var aboutTitle = "about-module--about-title--t2iQo";
export var profileImg = "about-module--profile-img--UNzMd";
export var quotes = "about-module--quotes--2C6v9";